/**
 * Normalizza l'id di un evento Google prima di persisterlo.
 *
 * Gli eventi Google nello store calendario hanno id interno `google-<idReale>`:
 * storicamente i drawer/modali salvavano quell'id sporco in
 * sales_activities.google_event_id (24k+ righe in prod, NESSUN backfill per
 * scelta: lo storico resta sporco). Il frontend fa strip difensivo, e ogni
 * consumer server-side (core/edge) DEVE fare `replace(/^google-/,'')` prima di
 * chiamare le API Google. Da qui in poi si persiste SOLO l'id pulito.
 */
export function normalizeGoogleEventId(id: string | null | undefined): string | null {
  if (!id) return null;
  return id.replace(/^google-/, '');
}
